import { render } from "./OnlineExamStats.vue?vue&type=template&id=083319f6&scoped=true"
import script from "./OnlineExamStats.vue?vue&type=script&lang=js"
export * from "./OnlineExamStats.vue?vue&type=script&lang=js"

import "./OnlineExamStats.vue?vue&type=style&index=0&id=083319f6&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083319f6"]])

export default __exports__